import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M9.358 18.358a8 8 0 0 0 8.465 1.833l.269-.1a2 2 0 0 0 .712-3.287l-1.606-1.606a2 2 0 0 0-2.577-.213l-.742.53a2 2 0 0 1-2.577-.213l-2.604-2.604a2 2 0 0 1-.213-2.577l.53-.742a2 2 0 0 0-.213-2.577L7.196 5.196a2 2 0 0 0-3.286.712l-.101.269a8 8 0 0 0 1.834 8.466z"
    }
  )
);
var SvgCallFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallFilled_default = SvgCallFilled;

export { CallFilled_default as default };
